import React from "react";

/** Page-loading mark: just the cpenz wordmark, black on white, slowly revealing itself. */
export function CPENZLoader({ size = 96, label = "", className = "", speed = 1 }) {
  return (
    <div className={`inline-flex flex-col items-center gap-4 ${className}`} role="status" aria-live="polite" aria-label="CPENZ.IO" data-testid="cpenz-loader">
      <span className="cpenz-loader-word font-bold text-[#0b0f1a] leading-none" style={{ fontSize: Math.max(16, size * 0.22), letterSpacing: "0.32em", paddingLeft: "0.32em" }} aria-hidden="true">
        {"CPENZ.IO".split("").map((ch, i) => <span key={i} className="cpenz-loader-letter" style={{ animationDelay: `${(0.35 + i * 0.2) / speed}s`, animationDuration: `${1.6 / speed}s` }}>{ch}</span>)}
      </span>
      {label && <p className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-400">{label}</p>}
    </div>
  );
}
